module.exports = __webpack_public_path__ + "static/assets/7208661b59e773ef1a678a72fce52b21.svg";